import './App.css';
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Dictionary/>
<footer className="repository">
 < a href="https://github.com/anpascott/dictionary-project.git"> Open-source code</a> by Andrea P.
</footer>
      </div>  
    </div>
  );
}

export default App;
